import { render, staticRenderFns } from "./SclAdd.vue?vue&type=template&id=afe5cf24&scoped=true&"
import script from "./SclAdd.vue?vue&type=script&lang=js&"
export * from "./SclAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe5cf24",
  null
  
)

export default component.exports